import { LoadingScreen } from '@avanta/shared/components/LoadingScreen';
import { useGetToken } from '@avanta/shared/hooks/useGetToken';
import { Suspense, type ReactElement } from 'react';
import { BrowserRouter as Router, Route, Routes, Outlet } from 'react-router';
import { ProtectedRoute } from 'components/ProtectedRoute';
import { PublicRoute } from 'components/PublicRoute';
import { TrackingProvider } from 'tracking/TrackingProvider';
import { FALLBACK_ROUTE, PRIVATE_PATHS, PUBLIC_ROUTES, ROOT } from './paths';

function AuthInitializer(): null {
  useGetToken();
  return null;
}

const RouterComponent = (): ReactElement => (
  <Suspense fallback={<LoadingScreen />}>
    <AuthInitializer />
    <Routes>
      <Route path={ROOT.path} element={<ProtectedRoute />} />
      {PRIVATE_PATHS.map(({ path, component, layout, roles }) => (
        <Route element={layout ?? <Outlet />} key={path}>
          <Route element={<ProtectedRoute allowedRoles={roles} />}>
            <Route path={path} element={component} />
          </Route>
        </Route>
      ))}
      {PUBLIC_ROUTES.map(({ path, component, layout }) => (
        <Route element={layout ?? <Outlet />} key={path}>
          <Route element={<PublicRoute />}>
            <Route path={path} element={component} />
          </Route>
        </Route>
      ))}
      <Route path={FALLBACK_ROUTE.path} element={FALLBACK_ROUTE.component} />
    </Routes>
  </Suspense>
);

export const AppRouter = (): ReactElement => (
  <Router>
    <TrackingProvider>
      <RouterComponent />
    </TrackingProvider>
  </Router>
);
